var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4402_21766",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4402_21766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.54813 14.5835C7.12715 14.5835 6.77083 14.4377 6.47917 14.146C6.1875 13.8543 6.04167 13.498 6.04167 13.077V3.58995C6.04167 3.16898 6.1875 2.81266 6.47917 2.521C6.77083 2.22933 7.12715 2.0835 7.54813 2.0835H14.5352C14.9562 2.0835 15.3125 2.22933 15.6042 2.521C15.8958 2.81266 16.0417 3.16898 16.0417 3.58995V13.077C16.0417 13.498 15.8958 13.8543 15.6042 14.146C15.3125 14.4377 14.9562 14.5835 14.5352 14.5835H7.54813ZM7.54813 13.3335H14.5352C14.5994 13.3335 14.6581 13.3068 14.7115 13.2533C14.7649 13.2 14.7917 13.1412 14.7917 13.077V3.58995C14.7917 3.52579 14.7649 3.46704 14.7115 3.4137C14.6581 3.36023 14.5994 3.3335 14.5352 3.3335H7.54813C7.48396 3.3335 7.42521 3.36023 7.37188 3.4137C7.3184 3.46704 7.29167 3.52579 7.29167 3.58995V13.077C7.29167 13.1412 7.3184 13.2 7.37188 13.2533C7.42521 13.3068 7.48396 13.3335 7.54813 13.3335ZM4.63146 17.5002C4.21049 17.5002 3.85417 17.3543 3.5625 17.0627C3.27083 16.771 3.125 16.4147 3.125 15.9937V5.25662H4.375V15.9937C4.375 16.0579 4.40174 16.1166 4.45521 16.17C4.50854 16.2234 4.56729 16.2502 4.63146 16.2502H12.8685V17.5002H4.63146Z",
    fill: "#949494"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.867711679376644412093a94b1331cbd.svg";
export { ForwardRef as ReactComponent };